import { getFormData } from "../../../../utilities/helper/formDataConvertor";
import request from "../../../axios";

export const updateProfile = async (payload: IUpdateUserProfilePayload) => {
  const {data}: {data: IResponse} = await request.put(
    `/api/profile/supplier-profile`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
  );
  return data;
};
